// extracted by mini-css-extract-plugin
module.exports = {"btn":"WorkerDetail_btn_2BT37"};